import React from 'react';
import { Modal, Button, message } from 'antd-v5';
import MassMessageForm from '../../../../shared/MassMessageForm';
import { useCreateMassMessage, useUpdateMassMessage } from '../../../../../hooks/query/useMassMessages';
import './MassMessageModal.scss';

const MassMessageModal = ({ open, onClose, eventId, audienceId, audienceCount, editingMessage }) => {
  const createMutation = useCreateMassMessage();
  const updateMutation = useUpdateMassMessage();

  const isEditMode = !!editingMessage;
  const isSaving = createMutation.isLoading || updateMutation.isLoading;

  const handleFormSubmit = async formData => {
    const payload = {
      ...formData,
      eventId,
      audience: { id: audienceId },
    };

    try {
      if (isEditMode) {
        await updateMutation.mutateAsync({ massMessageId: editingMessage.id, data: payload });
        message.success('Message updated successfully');
      } else {
        await createMutation.mutateAsync(payload);
        message.success('Message scheduled successfully');
      }
      onClose();
    } catch (error) {
      console.error('Error saving mass message:', error);
      message.error('Failed to save message. Please try again.');
    }
  };

  return (
    <Modal open={open} onCancel={onClose} width={900} footer={null} destroyOnClose className="mass-message-modal">
      <MassMessageForm
        audienceCount={audienceCount}
        editingMessage={open ? editingMessage : undefined}
        onSubmit={handleFormSubmit}
        isSaving={isSaving}
        showCostAlways
        renderActions={(handleSubmit, saving) => (
          <div className="mass-message-modal__header">
            <h2 className="mass-message-modal__title">Scheduled message</h2>
            <div className="mass-message-modal__header-actions">
              <Button type="primary" onClick={handleSubmit} loading={saving}>
                Schedule to Send
              </Button>
            </div>
          </div>
        )}
      />
    </Modal>
  );
};

export default MassMessageModal;
